import { cn } from "@jana-technology/platform-ui";
import type { InterventionCardHeadingProps } from "./types";

export const InterventionCardHeading = ({
  heading,
  children,
}: InterventionCardHeadingProps) => {
  return (
    <span className="flex items-baseline justify-between">
      <span className="mr-6">{heading}</span>
      <div
        className={cn({
          "flex items-baseline": children,
        })}
      >
        <span className="mr-4 text-sm text-grey-500">
          OR-Operational Risk | IR-Intervention Risk
        </span>
        {children}
      </div>
    </span>
  );
};

export default InterventionCardHeading;
